import { Checkbox, CheckboxProps } from 'antd';
import clx from 'classnames';
import React from 'react';
import styled from 'styled-components';
import { useInputController } from '../hooks/useInputController';
import { IsBooleanCheckboxElementSymbol } from '../item/symbols/isBooleanCheckboxElement';
import { useFormItemAccessibility } from '../item/useFormItemAccessibility';
import { useFormItemEnabled } from '../item/useFormItemEnabled';

const StyledCheckbox = styled(Checkbox)`
  &.read-only {
    pointer-events: none;
  }
`;

export interface ICheckboxInputProps extends Omit<CheckboxProps, 'name'> {
  name: string;
  /**
   * Aggungiamo proprietà readOnly non gestita da antd
   */
  readOnly?: boolean;
  onAfterChange?: (value: boolean) => void;
}

export function CheckboxInput(props: ICheckboxInputProps) {
  const { name, readOnly, className, onAfterChange, ...inputProps } = props;

  const { enabled, layoutEnabled } = useFormItemEnabled();

  const {
    field: { value, onChange, onBlur, ref },
  } = useInputController(name, { enabled });

  const accessibility = useFormItemAccessibility();

  return (
    <StyledCheckbox
      {...accessibility.attributes}
      disabled={enabled === false || layoutEnabled === false}
      {...inputProps}
      // {...field}
      // value={value}
      checked={value}
      onChange={
        readOnly
          ? undefined
          : e => {
              onChange(e.target.checked);
              onBlur();
              onAfterChange?.(e.target.checked);
            }
      }
      ref={ref}
      onClick={readOnly ? undefined : inputProps.onClick}
      className={clx(className, { 'read-only': readOnly })}
    />
  );
}
CheckboxInput[IsBooleanCheckboxElementSymbol] = true;
